<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title1" id="fm-2"><a id="page_4">Author’s Notes</a></h1><a id="page_4">
<p class="indent-para1">The town in my story is fictional but with a little imagination it could be my home turf, or it could be your community.</p>
<p class="indent-para">The people inhabiting the pages are fictional too but some do encompass characteristics of the many persons I’ve met over my years of writing. That’s why each might become so real for many readers.</p>
<p class="indent-para">The story, although a work of fiction, has some elements of truth about it because there are always eccentric characters who share similarities in behavior, in every community.</p>
<p class="indent-para">I would like to thank my husband, Teddy, who is always so kind and considerate about giving me quiet time to write. Thank you, Patricia Hunter, author of <em>Our Master Caesar</em>, for all your editing and advice. Thanks also must be given to Lorraine Bride, a kind friend who I have saluted by naming a character in the book after her.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Author_Note.vue?487f1905